import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription, combineLatest } from 'rxjs';

export const CUSTOM_TITLE_MARKER = 'CUSTOM';

@Injectable({ providedIn: 'root' })
export class TitleService extends TitleStrategy {
  readonly #title = inject(Title);
  readonly #translateService = inject(TranslateService);

  readonly #defaultTitle = 'Optimo';

  #translation$?: Subscription;

  public updateTitle(snapshot: RouterStateSnapshot): void {
    const titleTranslationKey = this.buildTitle(snapshot);
    this.setTitle(titleTranslationKey);
  }

  public setCustomTitle(translationParts: Observable<string>[]): void {
    this.#translation$?.unsubscribe();
    this.#translation$ = combineLatest(translationParts).subscribe((translatedParts) => {
      this.#title.setTitle(`${translatedParts.join(' | ')} | ${this.#defaultTitle}`);
    });
  }

  private setTitle(titleTranslationKey?: string): void {
    if (!titleTranslationKey || titleTranslationKey === CUSTOM_TITLE_MARKER) return;

    this.#translation$?.unsubscribe();
    this.#translation$ = this.#translateService.stream(titleTranslationKey).subscribe((translatedTitle) => {
      if (translatedTitle) {
        this.#title.setTitle(`${translatedTitle} | ${this.#defaultTitle}`);
      } else {
        this.#title.setTitle(this.#defaultTitle);
      }
    });
  }
}
